/* eslint-disable @typescript-eslint/no-unused-vars */

export default class VibrateBase {
  constructor() {
    //
  }

  public async vibrate(_pattern: number | number[]): Promise<boolean> {
    return Promise.reject(new Error("vibrate.base.vibrate must be overridden in the subclass"));
  }
}